<template>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
    <div class="datatables">
      <div class="block block-mode-hidden">
        <div v-if="tableLoader && showLoader" class="overlay"></div>
        <hash-loader v-if="tableLoader && showLoader" class="hash-icon table-hash-icon" color="#70B9EB" loading="loading" size="40" sizeUnit="px"></hash-loader>
        <div class="block-header bg-info">
          <h3 class="block-title text-white">
            <i class="fa fa-door-open"></i> Rooms ({{ Object.keys(rooms).length }})
            <span class="hash-loader" v-if="showLoader && !tableLoader">
              <hash-loader class="hash-icon" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
            </span>
          </h3>
          <div class="block-options">
            <button type="button" class="btn-block-option text-white" @click.prevent="showModifyRoomModal(false, null)">
            <i v-bind:disabled="showLoader" class="si si-plus"></i> Add New
            </button>
            <button @click="tableLoader = !tableLoader" v-bind:disabled="showLoader" type="button" class="btn-block-option text-white" data-toggle="block-option" data-action="content_toggle"></button>
          </div>
        </div>
        <div class="block-content block-content-full">
          <table id="rooms-table" class="table table-bordered table-striped table-vcenter js-dataTable-full table-sm">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Room</th>
                <th class="no-sorting">Functions</th>
              </tr>
            </thead>
            <tbody>{{ getRoomEntries }}
              <tr v-for="(room, index) in rooms" :key="index">
                <td class="text-center font-size-sm">{{ room.Id }}</td>
                <td class="font-w600 font-size-sm text-break-large">{{ room.Name }}</td>
                <td>
                  <a href="#" title="Edit" @click.prevent="showModifyRoomModal(true, room)">
                  <i class="fa fa-fw fa-pencil-alt"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!--Room modal-->
    <ModifyRoom ref="modifyRoom" @showSuccessMsg="showSuccessModal" @loadRooms="fetch"></ModifyRoom>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import ModifyRoom from '@/components/modals/ModifyRoom';
Vue.use(VueSpinners);

export default {
  name: 'Room',
  data() {
    return {
      isTableEnabled: false,
      rooms: [],
      showLoader: false,
      tableLoader: false
    };
  },
  components: {
    HashLoader,
    ModifyRoom
  },
  created() {
    this.fetch(false);
  },
  computed: {
    getRoomEntries() {
      if (this.$store.state.library.rooms.length) {
        return this.enableDataTable(this.$store.state.library.rooms);
      }
    }
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    ...mapActions('library', ['getAllRooms']),
    ...mapGetters('library', ['getRooms']),
    async fetch(force) {
      if (force || this.getRooms().length === 0) {
        this.showLoader = true;
        await this.getAllRooms();
      }
      if (this.getRooms().length === 0) {
        this.enableDataTable([]);
      }
    },
    enableDataTable(data) {
      let vm = this, table;
      vm.showLoader = true;
      if (vm.isTableEnabled) {
        table = jQuery('#rooms-table').DataTable();
        table.destroy();
      }
      vm.rooms = data;
      vm.prepareDataTable('#rooms-table');
      vm.isTableEnabled = true;
      vm.showLoader = false;
    },
    showSuccessModal(message) {
      this.success(message);
      this.triggerMessageModal('#alert_modal');
    },
    showModifyRoomModal(isEdit, room) {
      if (isEdit) {
        this.$refs.modifyRoom.loadRoom(room);
      }
      jQuery('#modify_room').modal('show');
    }
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>



// WEBPACK FOOTER //
// source/components/boxes/Room.vue